import api from '@tyrio/api-factory';
import { DBCustomPriceCatalogApi } from '@tyrio/dto';
import { ToastHelper, ToastType } from '@tyrio/ui-library';
import { useMutation, useQueryClient } from 'react-query';

export const useUpdateStatus = () => {
  const queryClient = useQueryClient();

  const updateStatus = useMutation(
    (req: DBCustomPriceCatalogApi['updateStatus']['request']) =>
      api.fetch<DBCustomPriceCatalogApi['updateStatus']>('cpc_update_status', {
        ...req,
      }),
    {
      mutationKey: 'cpc_update_status',
      onSuccess: () => {
        queryClient.refetchQueries('cpc_get_catalog');
      },
      onError: () => {
        ToastHelper.showToast(
          'Custom prices',
          ToastType.ERROR,
          undefined,
          'There is an error during updating price status!'
        );
      },
    }
  );

  return { updateStatus };
};
